import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CrownIcon } from 'assets/icons';
import UpgradeButton from './UpgradeButton';
import {
  StyledContainer,
  StyledTextContainer,
  StyledTitleTypography,
  StyledTypography,
  StyledTextSection,
  StyledCheckIcon,
} from './styled';

const UpgradeContainer = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledTextSection>
        <StyledTextContainer>
          <CrownIcon />
          <StyledTitleTypography>
            {t('account:youtubeChannel:upgradeContainer:title')}
          </StyledTitleTypography>
        </StyledTextContainer>
        <Box>
          <StyledTextContainer>
            <StyledCheckIcon />
            <StyledTypography>
              {t(
                'account:youtubeChannel:upgradeContainer:avoidCopyrightClaims'
              )}
            </StyledTypography>
          </StyledTextContainer>
          <StyledTextContainer>
            <StyledCheckIcon />
            <StyledTypography>
              {t('account:youtubeChannel:upgradeContainer:monetizeYourContent')}
            </StyledTypography>
          </StyledTextContainer>
        </Box>
      </StyledTextSection>
      <UpgradeButton />
    </StyledContainer>
  );
};

export default UpgradeContainer;
